const API_URL = process.env.REACT_APP_API_URL || "/api";

export async function fetchWithAuth(url, options = {}) {
    let response = await fetch(API_URL + url, {
      ...options,
      credentials: 'include',  // Ensures cookies are sent
    });
  
    if (response.status === 401) {
      console.log("Access token expired, trying refresh...");
      
      // Call refresh token endpoint
      const refreshResponse = await fetch(API_URL + '/refresh', {
        method: 'POST',
        credentials: 'include',  // Include cookies
      });
  
      if (refreshResponse.ok) {
        console.log("Token refreshed, retrying request...");
        response = await fetch(API_URL + url, {
          ...options,
          credentials: 'include',
        });
      } else {
        console.log("Refresh token expired. Redirecting to login...");
        window.location.href = "/login";
        return;
      }
    }
  
    return response.json();
  };
